import { dashBoardNotifications } from "assets/data/dashboard";
import { Link } from "react-router-dom";
import { Card, CardFilter, PushNotification } from "ui";
const NotificationsCard = () => {
    return (
        <Card className="w-full h-full flex flex-col gap-5">
            <div className="flex flex-col justify-start items-start gap-2 dark:text-white">
                <h2 className="text-lg font-medium">Push Notifications</h2>
                <CardFilter
                    dropDownItems={[
                        "Notitification ID",
                        "Title",
                        "Message",
                        "Country",
                        "Language",
                        "Topics"
                    ]}
                />
            </div>
            <div className="flex flex-col justify-start items-center gap-5 py-2 w-full h-full bg-neutral-50 dark:bg-momeento-100 rounded overflow-auto">
                {dashBoardNotifications.map((n) => (
                    <PushNotification noti={n} key={n.id} />
                ))}
            </div>
            <div className="w-full text-center">
                <Link
                    to="/notifications"
                    className="w-fit px-5 py-2 text-sm text-center bg-momeento-50 text-white hover:shadow-xl rounded-full"
                >
                    View More...
                </Link>
            </div>
        </Card>
    );
};

export default NotificationsCard;
